<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑岗位
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="岗位编码">
                    <el-input  v-model="form.rnumber" placeholder="岗位编码系统自动生成"  disabled></el-input>
                </el-form-item>
                <el-form-item label="岗位名称" prop="roleName" required>
                    <el-input  v-model="form.roleName" placeholder="请输入岗位名称"></el-input>
                </el-form-item>
                <el-form-item label="岗位类型">
                    <el-select v-model="form.roleType" placeholder="请选择岗位类型" style="width:100%">
                        <el-option label="公司岗位" value="公司岗位"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>






            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        data() {
            return {
                tree_model: {
                    id: this.formData.p_id,
                    name: this.formData.p_name
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'p_id',
                    children: 'child'
                },
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px'
            };
        },
        mounted() {
            // this.getMenuFolder();
            // this.tree_model = {
            //   id: this.formData.p_id,
            //   name: this.formData.p_name
            // }
        },
        methods: {
            // async getMenuFolder() {
            //   this.dialoading = true;
            //   let param = {
            //   }
            //   const data = await this.$sqlOpt.menu.getMenuFolder(param)
            //   this.dialoading = false;
            //   if (data.code === "1") {
            //     this.treeData = data.data;
            //   }
            // },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                // this.form.p_id = this.tree_model.id;
                // this.form.p_name = this.tree_model.name;

                if(this.form.roleName==null){
                    this.$message({message: '请输入岗位名称', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form);
            },
        }
    }
</script>
